import { render } from "./EditBirthdayModalControl.vue?vue&type=template&id=e63d207e&scoped=true"
import script from "./EditBirthdayModalControl.vue?vue&type=script&lang=js"
export * from "./EditBirthdayModalControl.vue?vue&type=script&lang=js"

import "./EditBirthdayModalControl.vue?vue&type=style&index=0&id=e63d207e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63d207e"]])

export default __exports__